import { UiStringModel } from "./ui-string.model";

declare global {
  var checkout: CheckoutConfig | undefined;
}

export interface CheckoutConfig {
  isEventListingWidget: boolean;
  widgetEventId: number;
  widgetType: string;
  isWhiteLabel: boolean;
  isWidget: boolean;
  isInEU: boolean;
  isCardSwipeEnabledForAll: boolean;
  showCarousel: boolean;
  collectAddressIsMandatory: boolean;
  collectPhoneNumberIsMandatory: boolean;
  accountId: number;
  permissionToSendPromotionalEmails: boolean;
}

export const getCheckoutConfig = (): CheckoutConfig | undefined => {
  return window.checkout;
}

